import { Injectable } from '@angular/core';
import { AuthChangeEvent, createClient, Session, SupabaseClient } from '@supabase/supabase-js';
import { environment } from '../environments/environment';
import { Database } from '../data/database.types';
import { windowDebug } from '../tools/debug';

@Injectable({providedIn: 'root'})
export class SupabaseService {
  client = createClient<Database>(
    environment.supabase.url,
    environment.supabase.key
  );

  constructor() {
    windowDebug('Supabase', this);
  }




  uploadImage(filePath: string, file: File) {
    return this.client.storage.from('images').upload(filePath, file);
  }

  downloadImage(filePath: string) {
    return this.client.storage.from('images').download(filePath);
  }

}
